import React from 'react';
import { type Task, Checklist } from '@atlassiansox/checklist';
import { useIntl } from '@atlassian/jira-intl';
import { useActions, useOpenTaskId, useTasks } from '../services/index.tsx';
import { OnboardingCheckListPostTasks } from './OnboardingCheckListPostTasks.tsx';

type TaskDictionary = Record<string, Omit<Task, 'completed'>>;

export const OnboardingCheckList = ({ taskDictionary }: { taskDictionary: TaskDictionary }) => {
	const { formatMessage } = useIntl();

	const tasks = useTasks();
	const openTaskId = useOpenTaskId();
	const { closeCurrentTask, setOpenTaskId } = useActions();

	if (!tasks) {
		return null;
	}

	// TODO: POL-17792 handle the case where the task is not in the taskDictionary
	const tasksToRender = tasks.items.map((task) => {
		return {
			...taskDictionary[task.id],
			completed: task.completed,
		};
	});

	return (
		<Checklist
			tasks={tasksToRender}
			isOpen
			onClose={closeCurrentTask}
			title={formatMessage(tasks.title)}
			expandedTask={openTaskId ?? undefined}
			onTaskExpand={setOpenTaskId}
			postTasksComponent={<OnboardingCheckListPostTasks />}
		/>
	);
};
